import React from 'react';
// import { authRoles } from '../../auth/authRoles';

//navigations.jsで使用
const shopRoutes = [
	{
		path: '/analytics-sales', //URL
		component: React.lazy(() => import('./AnalyticsSales')), //遅延ロード用のコンポーネントをimportする
	},
	{
		path: '/analytics-shop', //URL
		component: React.lazy(() => import('./AnalyticsShop')), //遅延ロード用のコンポーネントをimportする
	},
];

export default shopRoutes;
